const CALENDAR_ID_AC = 'a9pvq2b9gs9umqelf3pn8vae6c@group.calendar.google.com';
const CALENDAR_ID_PZR = '9lfrp63ta3e72biqgj62spee2c@group.calendar.google.com';

export const BASE_URL = 'https://termin.hemacare.de';

export const dates = {
  Montag:{
    start: '09:00',
    end: '17:00',
  },
  Dienstag:{
    start: '12:00',
    end: '20:00',
  },
 Mittwoch:{
    start: '09:00',
    end: '15:00',
  },
Donnerstag:{
    start: '12:00',
    end: '20:00',
  },
Freitag:{
    start: '09:00',
    end: '15:00',
  },
};

export const insuranceTypes = [
  { id: 0, name: 'Bitte auswählen' },
  { id: 1, name: 'Gesetzlich versichert' },
  { id: 2, name: 'Privat versichert' },
];

export const genderTypes = [
  
  {
    id: 1,
    name: 'Herr',
  },
  {
    id: 2,
    name: 'Frau',
  },
  {
    id: 3,
    name: 'Kind',
  },
  {
    id: 4,
    name: 'Divers',
  },
];

export const treatmentReasons = [
  {
    id: 0,
    name: 'Bitte auswählen',
    limits: [],
    calendarId: CALENDAR_ID_AC,
  },
  {
    id: 1,
    name: 'Schmerzbehandlung',
    limits: [],
    calendarId: CALENDAR_ID_AC,
  },
  {
    id: 2,
    name: 'Kontrolle',
    limits: [],
    calendarId: CALENDAR_ID_AC,
  },
  {
    id: 3,
    name: 'Professionelle Zahnreinigung',
    limits: [
      { day: 'Mo', max: 4 },
      { day: 'Di', max: 4 },
      { day: 'Mi', max: 0 },
      { day: 'Do', max: 4 },
      { day: 'Fr', max: 4 },
    ],
    calendarId: CALENDAR_ID_PZR,
  },
  {
    id: 4,
    name: 'Anderer Grund',
    limits: [],
    calendarId: CALENDAR_ID_AC,
  },
];
